import {Box, Typography} from '@viptech/react-components'
import Slider from 'src/components/slider'
import {ChosenObject} from '../../StepperModal'
import {LabelsSlider} from './ConfigStepBase'

type Props = {
  chosen: ChosenObject | null
  valueSlider: number | null
  setValueSlider: (value: number | null) => void
}

const ConfidenceSliderComponent = (props: Props) => {
  const {chosen, valueSlider, setValueSlider} = props

  const TitleAndLabelComponent = ({title, label}: {title: string; label: string}) => {
    return (
      <Box>
        <Typography variant='span' size='16px' style={{fontWeight: 500}}>
          {title}
        </Typography>
        <Typography variant='p' size='12px' color='#8E8E8E'>
          {label}
        </Typography>
      </Box>
    )
  }

  const maxValueOnSlider = 100
  const minValueOnSlider = 10
  const labelOnSlider = chosen?.detectionTypeChosen?.includes('Facial')
    ? 'Escolha o percentual de confiança da detecção de faces. Valores altos tornam a detecção mais rigorosa, enquanto valores baixos permitem maior variação. A nossa sugestão é 30%.'
    : `Escolha abaixo o nível de sensibilidade para detecção de ${chosen && chosen.detectionTypeChosen?.toLowerCase()}. Uma sensibilidade muito alta irá
            disparar menos eventos, e um nível muito baixo irá disparar muitos eventos, podendo resultar em falsos positivos.`

  const dontShowThresholdComponentTo = ['placa', 'leitura de placas', 'tempo de permanência']
  if (dontShowThresholdComponentTo.includes(chosen?.detectionTypeChosen?.toLowerCase() ?? '')) return <></>
  return (
    <Box>
      <TitleAndLabelComponent title='Nível de confiança' label={labelOnSlider} />

      {valueSlider && (
        <Slider
          background='linear-gradient(to right,#ff0000bc,  #ff880063 5% 10%, #009d34 21% 70%, #ff880063, #ff0000bc 104% )'
          max={maxValueOnSlider}
          min={minValueOnSlider}
          width='100%'
          bubble={true}
          value={valueSlider}
          setValue={setValueSlider}
        />
      )}
      <Box display='flex' align='center' justifyContent='space-between'>
        <LabelsSlider>Baixo demais</LabelsSlider>
        <LabelsSlider>Ideal</LabelsSlider>
        <LabelsSlider>Alto demais</LabelsSlider>
      </Box>
    </Box>
  )
}

export default ConfidenceSliderComponent
